import React, { ComponentProps } from "react";

import "./Skeleton.scss";
import { ThemeVariant } from "../../utils/constants/generic-types";

export interface SkeletonProps extends ComponentProps<"div"> {
  isLoading?: boolean;
  height?: string | number;
  width?: string | number;
  borderRadius?: string | number;
  children?: React.ReactNode;
  variant?: "default" | "rounded";
  theme?: ThemeVariant;
  shimmerStyle?: React.CSSProperties;
}

const Skeleton: React.FC<SkeletonProps> = ({
  style,
  children,
  className = "",
  isLoading = true,
  height = "16px",
  width = "100%",
  borderRadius = "8px",
  variant = "default",
  theme = ThemeVariant.LIGHT,
  shimmerStyle,
  ...restProps
}) => {
  if (!isLoading) return <>{children}</>;

  return (
    <div
      className={`skeleton ${className}`}
      style={{
        height,
        width,
        borderRadius: variant === "default" ? borderRadius : 9999,
        background: theme === ThemeVariant.DARK ? "#0c0c0c" : undefined,
        ...style,
      }}
      {...restProps}
    >
      <div
        className="moving-bar"
        style={{
          background: theme === ThemeVariant.DARK ? "#111111" : undefined,
          ...shimmerStyle,
        }}
      />
    </div>
  );
};

export default Skeleton;
